import React from 'react';
import { Table } from '@tanstack/react-table';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';
import { NpsCampaignDtoStatus } from '@area-restrita/api-client/model/npsCampaignDtoStatus';

import { NPS_STATUS_LABELS } from '@/modules/nps/utils';
import { Input } from '@/components/ui/input';
import DataTableToolbar from '@/components/DataTable/DataTableToolbar';
import CompanyQueryFilter from '@/components/QueryFilters/CompanyFilter';
import DataTableFacetedFilter from '@/components/DataTable/DataTableFacetedFilter';

interface IProps {
  table: Table<NpsCampaignDto>;
  showCompanyFilter?: boolean;
  statuses?: NpsCampaignDtoStatus[];
}

const NpsCampaignFilters: React.FC<IProps> = ({
  table,
  showCompanyFilter = true,
  statuses = Object.keys(NPS_STATUS_LABELS) as NpsCampaignDtoStatus[],
}) => {
  const periodStart =
    (table.getColumn('periodStart')?.getFilterValue() as string) ?? '';
  const periodEnd =
    (table.getColumn('periodEnd')?.getFilterValue() as string) ?? '';

  return (
    <DataTableToolbar
      table={table}
      className="grid w-full flex-none grid-cols-2 gap-2 xl:flex xl:flex-1 xl:flex-wrap"
      searchClassName="col-span-2 w-full sm:w-full lg:w-full xl:w-[250px]"
      searchPlaceholder="Buscar campanha..."
      searchColumnId="name"
    >
      {showCompanyFilter && (
        <CompanyQueryFilter
          className="w-full justify-start xl:w-auto"
          title="Empresa"
          column={table.getColumn('companyIds')}
        />
      )}

      <DataTableFacetedFilter
        className="w-full justify-start xl:w-auto"
        title="Status"
        options={statuses.map((value) => ({
          label: NPS_STATUS_LABELS[value],
          value,
        }))}
        column={table.getColumn('status')}
      />

      <Input
        type="date"
        value={periodStart}
        onChange={(event) =>
          table
            .getColumn('periodStart')
            ?.setFilterValue(event.target.value || undefined)
        }
        className="h-8 min-w-0 w-full xl:w-[150px]"
      />

      <Input
        type="date"
        value={periodEnd}
        onChange={(event) =>
          table
            .getColumn('periodEnd')
            ?.setFilterValue(event.target.value || undefined)
        }
        className="h-8 min-w-0 w-full xl:w-[150px]"
      />
    </DataTableToolbar>
  );
};

export default NpsCampaignFilters;
